import Character from "@lss/common/src/shell/Character";


interface ActorINT {
}

const actorProperties: ActorINT = {
}

export const actor = new Character<ActorINT>("Actor", actorProperties, "#6391FFFF");
